import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import AccrodianBox from "../../component/AccrodianBox";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import AlertBox from "../../component/AlertBox";
import { LinearProgress } from "@mui/material";
import DialogBox from "../../component/DialogBox";
import { WordLimitIndicator } from "../../utils/WordLimitIndicator";

function EditTemplate() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.letterGenerate === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedYS, setSelectedYS] = useState("");
  const [selectedDesig, setSelectedDesig] = useState("");
  const [letterContent, setLetterContent] = useState("");
  const [letterHeading, setLetterHeading] = useState("");
  const [selectedTAndC, setSelectedTAndC] = useState([]);
  const [termHeading, setTermsHeading] = useState("");
  const [termContent, setTermContent] = useState("");
  const { templateId } = useParams();
  // flag for word limit
  const [letterHeadingFlag, setLetterHeadingFlag] = useState(true);
  const [letterContentFlag, setLetterContentFlag] = useState(true);

  // fetch template
  async function getTemplate() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/template/get/single/${templateId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      const rawData = res.data?.data
      setLetterContent(rawData?.template)
      setLetterHeading(rawData?.title)
      setSelectedYS(rawData?.sender)
      setSelectedDesig(rawData?.senderDesignation)
      setSelectedTAndC(rawData?.termsArray)
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("History fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getTemplate()
  },[templateId])

  // add term to array
  function addTerm() {
    setSelectedTAndC((prev) => {
      let prevArr = prev;
      const obj = {
        title: termHeading,
        body: termContent,
      };
      prevArr.push(obj);
      return [...prevArr];
    });
  }

  // delete term
  function deleteTerm(index) {
    setSelectedTAndC((prev) => {
      let prevArr = prev;
      prevArr.splice(index, 1);
      console.log(prevArr)
      return [...prevArr];
    });
  }

  // edit template
  async function saveTemplate() {
    if (
      selectedYS?.length === 0 ||
      selectedDesig?.length === 0 ||
      letterContent?.length === 0 ||
      letterHeading?.length === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please complete the STEP 1");
      return null;
    }
    const data = {
      template: letterContent,
      sender: selectedYS,
      senderDesig: selectedDesig,
      termsArr: selectedTAndC,
      title: letterHeading,
      templateId: templateId
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/template/edit`,
        method: "put",
        withCredentials: true,
        data: data,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Letter template has been saved successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Template save failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <section>
            <section className="flex justify-between items-center">
              <h1 className="text-[30px] font-medium text-left w-full">
                Add Template
              </h1>
            </section>
          </section>
          <div className="w-full mt-5">
            <div>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 1
                    </span>{" "}
                    <span
                      className={
                        letterHeadingFlag === false ||
                        letterContentFlag === false
                          ? "text-red-600 font-medium"
                          : "text-slate-700 font-medium"
                      }
                    >
                      Template Settings
                    </span>
                  </p>
                }
                id={1}
                defaultExpanded
              >
                <div className="space-y-3">
                  <section>
                    {letterHeading.length > 0 && (
                      <section className="flex justify-end">
                        <WordLimitIndicator
                          limit={50}
                          words={letterHeading}
                          setFlag={setLetterHeadingFlag}
                        />
                      </section>
                    )}
                    <InputField
                      label="Title"
                      onChange={(eve) => setLetterHeading(eve?.target?.value)}
                      required
                      color={letterHeadingFlag === true ? "" : "error"}
                      value={letterHeading}
                    />
                  </section>
                  <section>
                    {letterContent.length > 0 && (
                      <section className="flex justify-end">
                        <WordLimitIndicator
                          limit={4000}
                          words={letterContent}
                          setFlag={setLetterContentFlag}
                        />
                      </section>
                    )}
                    <InputField
                      multiline
                      required
                      rows={20}
                      label="Template"
                      onChange={(eve) => setLetterContent(eve?.target?.value)}
                      color={letterContentFlag === true ? "" : "error"}
                      value={letterContent}
                    />
                  </section>
                  <section className="grid grid-cols-2 gap-5">
                    <InputField
                      label="Your Sincerely"
                      onChange={(eve) => setSelectedYS(eve?.target?.value)}
                      required
                      value={selectedYS}
                    />
                    <InputField
                      label="Designation"
                      onChange={(eve) => setSelectedDesig(eve?.target?.value)}
                      required
                      value={selectedDesig}
                    />
                  </section>
                </div>
              </AccrodianBox>
              <AccrodianBox
                title={
                  <p className="text-slate-800 font-medium">
                    <span className="bg-slate-200 text-slate-600 py-2 px-3 font-semibold rounded-full text-[15px]">
                      STEP 2
                    </span>{" "}
                    Terms & Conditions
                  </p>
                }
                id={3}
              >
                <div className="flex justify-end">
                  <DialogBox
                    trigger={<ButtonCompo>Add T&C</ButtonCompo>}
                    title="Add A T&C"
                    actionButton={
                      <ButtonCompo onClick={addTerm}>Add</ButtonCompo>
                    }
                  >
                    <div className="space-y-5">
                      <InputField
                        label="Title"
                        onChange={(eve) => setTermsHeading(eve?.target?.value)}
                      />
                      <InputField
                        label="Description"
                        onChange={(eve) => setTermContent(eve?.target?.value)}
                      />
                    </div>
                  </DialogBox>
                </div>
                {selectedTAndC?.length > 0 ? (
                  <div>
                    {selectedTAndC?.map((tcData, i) => (
                      <section key={i}>
                        <section className="mt-3">
                          <section className="text-slate-500 flex justify-start gap-5 items-end">
                            <div>
                              <span className="text-slate-700 font-semibold">
                                {tcData?.title}
                              </span>{" "}
                              {tcData?.body}
                            </div>
                            <section
                              className="text-red-500 font-medium uppercase cursor-pointer"
                              onClick={() => deleteTerm(i)}
                            >
                              Delete
                            </section>
                          </section>
                        </section>
                      </section>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col justify-center items-center gap-5">
                    <p className="text-center text-slate-500 font-medium">
                      No terms and conditions added yet
                    </p>
                  </div>
                )}
              </AccrodianBox>
            </div>
            <section className="flex justify-end mt-5">
              <ButtonCompo variant={"contained"} onClick={saveTemplate}>
                Update Template
              </ButtonCompo>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditTemplate;
